import '../scss/styles.scss';
import $ from "jquery";
import Landing from './Landing';
import Book from './Book';
import Contact from './Contact';


const landing = new Landing();
const book = new Book();
const contact = new Contact();

$(document).ready(function () {
  landing.initialPageAnimation();
  book.initialPageAnimation();

  // --- landing page buttons ---
  $('#js__landing__next').click(()=>{
    landing.getNextSlide();
  });
  $('#js__landing__prev').click(()=>{
    landing.getPrevSlide();
  });

  // --- product page buttons ---
  $('#js__book__next').click(()=>{
    book.getNextSlide();
  });
  $('#js__book__prev').click(()=>{
    book.getPrevSlide();
  });

  // --- contact form ---
  $('#ajax-contact').submit((event)=>{
    contact.sendEmail();
  });

  // product page change select
  $('#js__cover-type').change((e)=>{
    book.toggleBookType(e);
  });

  // producut page paypal value
  $('#js__hear').change((e)=>{
    book.setHear(e);
  });

  // mobile hamburger
  $('#js__hamburger').click(()=>{
    landing.toggleMenu();
  });


});



// WEBPACK FOOTER //
// src/scripts/index.js